import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-page">
      <div className="privacy-container">
        <h1 className="privacy-title">Privacy Policy</h1>
        
        <div className="privacy-intro">
          <p>
            PhoneVue Inc. ("we"/"us") provides this privacy policy in relation with the user ("you") of PhoneVue ("this app") as follows.
          </p>
        </div>

        <div className="privacy-article">
          <h2 className="article-title">1. Collector Information</h2>
          <p className="article-text">
            <strong>Name:</strong> PhoneVue Private Limited<br />
            <strong>Contact:</strong> info@phonevue.in
          </p>
        </div>

        <div className="privacy-article">
          <h2 className="article-title">2. Collected information, Purpose of Use, Method of Collection</h2>
          <p className="article-intro">
            <strong>(a)</strong> This app is made for inspection of parts, system and so on of a smartphone, notification to you of the malfunction or exhaustion or the possibility of them of the smartphone, and provision to you of opportunities to sell, buy, or exchange smartphones. For this purpose, we collect and share information with smartphone makers, smartphone parts makers, smartphone carriers and so on, and may also share or jointly use this information with foreign third parties who are foreign smartphone makers, smartphone parts makers, smartphone carriers and so on. In these cases, information collected from you may be processed or stored in Japan, US, Canada, UK, Switzerland, Ireland, Spain, Portugal, France, Italy, Germany, Netherlands, Belgium, Denmark, Austria, Sweden, Finland, Greece, Croatia, Slovakia, Slovenia, Czech Republic, Hungary, Bulgaria, Poland, Romania, India, Singapore, Malaysia, Indonesia, Australia, and UAE. In these cases, the information may also be provided to or jointly used with foreign third parties.
          </p>
          <ol className="article-list">
            <li>
              <strong>Information collected by user input and automatic transmission:</strong> name, phone number, email address, subscription number, order number, IMEI, password, country, date of birth.
            </li>
            <li>
              <strong>Information collected by app usage and automatic transmission:</strong> IDs peculiar to the smartphone and the subscriber of the smartphone (ID created by OS, Unique Device IDentifier, International Mobile Subscription Identity, International Mobile Equipment Identifier, MAC address, IP address and so on), information concerning the identification and the status of the parts of the smartphone, cookies, history of use of this app, smartphone maker, model, OS, version of OS, smartphone carrier and so on.
            </li>
          </ol>
          <p className="article-text" style={{ marginTop: '1rem' }}>
            <strong>(b)</strong> Use of information from (a)(1): for identity verification, notice concerning this app, notice concerning term of service and privacy policy and amendment of them, communication with you and reaction to the violation of term of service or privacy policy.
          </p>
          <p className="article-text">
            <strong>(c)</strong> Use of information from (a)(2): for improvement of this app and the service related to this app and development of new products and services.
          </p>
          <p className="article-text">
            <strong>(d)</strong> General use of information from (a): for the incidental or related purpose to the purposes stated above.
          </p>
        </div>

        <div className="privacy-article">
          <h2 className="article-title">3. Procedure of Acquisition of Consent</h2>
          <p className="article-text">
            We acquire your consent regarding your privacy right when you install or activate this app.
          </p>
        </div>

        <div className="privacy-article">
          <h2 className="article-title">4. Termination of Collection of Information</h2>
          <p className="article-text">
            Collection of information from you terminates when you uninstall this app, because collection of the information described in Article 2 is prerequisite to function this app.
          </p>
        </div>

        <div className="privacy-article">
          <h2 className="article-title">5. Provision of Information to Third Party, Joint Use of Information, Provision of Information to Foreign Third Party</h2>
          <p className="article-text">
            As stated in Article 2 (a) and 2 (b), we may provide or jointly use information collected from you to and with third parties, including third parties located in foreign countries. In such cases, we are responsible for the management of the information.
          </p>
          <p className="article-text" style={{ marginTop: '1rem' }}>
            We may also provide information to third parties, including those in foreign countries, without consent of you, when personal information protection law or other law or regulation allows us to do so without consent of you, which includes cases where providing personal data is necessary for the protection of the life, body or property or for improving public health or promoting the sound growth of children.
          </p>
        </div>

        <div className="privacy-article">
          <h2 className="article-title">6. Handling of Personal Information</h2>
          <p className="article-text">
            We may outsource all or part of the handling of personal information to the extent necessary to achieve the purpose of use. In this case, we will thoroughly examine the eligibility of the subcontractor, stipulate matters related to confidentiality obligations in the contract, and perform necessary and appropriate supervision of the subcontractor. In addition, we may jointly use all or part of the acquired personal information based on the provisions of the Personal Information Protection Law.
          </p>
        </div>

        <div className="privacy-article">
          <h2 className="article-title">7. Disclosure, Correction, Discontinuance and so on</h2>
          <p className="article-text">
            When you request us to disclose, correct, add, delete, discontinue or erase your personal information, if your request meets the requirement provided for in personal information protection law or other law or regulation and unless we do not have obligation to do so according to personal information protection law or other law or regulation, after identity verification of you, we do so. When you request these acts, please contact us by sending email to our email address stated in Article 7. Disclosure of information is processed by sending email to you in principle.
          </p>
        </div>

        <div className="privacy-article">
          <h2 className="article-title">8. Contact Information</h2>
          <p className="article-text">
            If you have question, comment or concern about privacy policy, please contact us by sending email to our email address stated below.
          </p>
          <p className="article-text" style={{ marginTop: '0.5rem' }}>
            <strong>Contact:</strong> info@phonevue.in
          </p>
        </div>

        <div className="privacy-article">
          <h2 className="article-title">9. Notification, Publication, Amendment of Privacy Policy</h2>
          <p className="article-text">
            Notification or publication of privacy policy or the amendment of privacy policy is made by description in this app, publication on our website, email or other proper method.
          </p>
          <p className="article-text" style={{ marginTop: '1rem' }}>
            We may amend privacy policy. We may request your consent to the amended privacy policy.
          </p>
        </div>

        <div className="privacy-date">
          <p className="date-text">Dated: 16th February 2024</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
